import { render, staticRenderFns } from "./checkupModal.vue?vue&type=template&id=3d77c2bc&scoped=true"
import script from "./checkupModal.vue?vue&type=script&lang=js"
export * from "./checkupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d77c2bc",
  null
  
)

export default component.exports